/* eslint-disable @angular-eslint/component-class-suffix */
/* eslint-disable @angular-eslint/component-selector */

import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';

type Size = 'sm' | 'md' | 'lg';

@Component({
    selector: '[luiFab]',
    template: `
    <span class="lui-fab-touch-container" matRipple>
      <ng-content></ng-content>
    </span>
  `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class Fab {
  private _model = 'lui-fab';
  @HostBinding('class') get hostClasses() {
    return {
      [`${this._model}`]: true,
      [`${this._model}-solid`]: this.isSolid,
      [`${this._model}-${this.size}`]: true,
    };
  }

  @Input() isSolid = false;
  @Input() size: Size = 'md';
}
